// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3TBRF","visuallyhidden":"_3SSMM","hide-text":"_2nxMc","center":"wdaU3","noprint":"_2Dx6x","date":"_3jFsm","root":"_1kU1Z"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-label/styles/default.scss
 ** module id = 1009
 ** module chunks = 2
 **/